export const MOBILE_SCREEN_SIZE = 768;
